/* eslint-disable jsx-a11y/control-has-associated-label */
// Header Component
import React, { useEffect, useState } from "react";

// Ui Components
import Navbar from "react-bootstrap/Navbar";
import WhelenSymbol from "../../assets/img/logo.svg";
import UserIcon from "../../assets/img/UserProfile.png";
import authService from "../../services/AuthService";

export default ({ handleSidebarToggle }) => {
  const [name, setName] = useState("");

  const getName = () => setTimeout(() => setName(authService.getName()), 1000);

  useEffect(() => {
    getName();
  }, []);

  return (
    <>
      {/* <header className="navbar d-print-none">
        <div className="container-fluid">
          <a href="#" className="navbar-toggler me-3" onClick={handleSidebarToggle}>
            <span className="navbar-toggler-icon" />
          </a>
          <div className="navbar-brand d-none-navbar-horizontal pe-auto flex-grow-1">
            <img src={WhelenSymbol} alt="" className="navbar-brand-image me-2" />
            <span className="d-none d-sm-flex">AOG Admin Console</span>
          </div>
          <div className="navbar-nav flex-row order-md-last">
            <div className="d-none d-md-flex me-2">
              <a
                href="?theme=light"
                className="nav-link px-0 hide-theme-light"
                data-bs-toggle="tooltip"
                data-bs-placement="bottom"
                aria-label="Enable light mode"
                data-bs-original-title="Enable light mode"
              >
                <i className="bi bi-light" />
              </a>
            </div>
            <div className="nav-item dropdown">
              <a
                href="#"
                className="nav-link d-flex lh-1 text-reset p-0"
                data-bs-toggle="dropdown"
                aria-label="Open user menu"
              >
                <span className="avatar avatar-sm" />
                <div className="d-none d-md-block ps-2">
                  <div>{name}</div>
                </div>
              </a>
              <div className="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                <a href="#" className="dropdown-item">
                  Status
                </a>
                <a href="./profile.html" className="dropdown-item">
                  Profile
                </a>
                <a href="#" className="dropdown-item">
                  Feedback
                </a>
                <div className="dropdown-divider" />
                <a href="./settings.html" className="dropdown-item">
                  Settings
                </a>
                <a href="./sign-in.html" className="dropdown-item">
                  Logout
                </a>
              </div>
            </div>
          </div>
        </div>
      </header> */}
      <Navbar className="header bg-gray-darker py-1 fixed-header">
        <div className="container-fluid gutters-0 p-0">
          <div className="d-flex col ml-md-auto align-items-center">
            <button
              type="button"
              className="menu-trigger me-4 link-button"
              aria-label="button"
              onClick={handleSidebarToggle}
            >
              <span />
              <span />
              <span />
            </button>
            <img src={WhelenSymbol} alt="" className="w-7" />
            <span className="h4 mb-0 fw-bolder d-none d-sm-inline-block me-auto">AOG Admin Console</span>
          </div>
          <div className="ms-auto">
            <div className="nav-link pr-0 leading-none" style={{ cursor: "default" }}>
              <span className="d-none d-lg-block" style={{ width: "min-content" }}>
                <span className="text-white">{name}</span>
              </span>
              <span className="ms-2 avatar avatar-sm">
                <img className="img-profile rounded-circle" alt="" src={UserIcon} />
              </span>
            </div>
          </div>
        </div>
      </Navbar>
    </>
  );
};
